export default [
  {
    path: '/admin/quiz',
    name: 'indexQuizAdmin',
    meta: { title: 'indexQuizAdmin' },
    component: () => import('@/pages/admin/quiz'),
  },
]
